import baseForm from '@/components/form/'
const baseInput = () => import(/* webpackChunkName: "form-Input" */ '@/components/form/input/')
const email = () =>
    import(/* webpackChunkName: "form-input-email" */ '@/components/form/input/email')
const addressInput = () =>
    import(/* webpackChunkName: "form-input-email" */ '@/components/form/input/address')
const phone = () =>
    import(/* webpackChunkName: "form-input-phone" */ '@/components/form/input/phone')
const fullName = () =>
    import(/* webpackChunkName: "form-input-fullName" */ '@/components/form/input/fullName')
const baseCheckbox = () =>
    import(/* webpackChunkName: "form-checkbox" */ '@/components/form/checkbox/')
const baseRadio = () => import(/* webpackChunkName: "form-radio" */ '@/components/form/radio/')
const baseSelect = () => import(/* webpackChunkName: "form-select" */ '@/components/form/select/')
const baseTextarea = () =>
    import(/* webpackChunkName: "form-textarea" */ '@/components/form/textarea/')

export default {
    components: {
        baseForm,
        baseSelect,
        baseCheckbox,
        baseRadio,
        baseInput,
        addressInput,
        email,
        phone,
        fullName,
        baseTextarea,
    },
}
